import * as Adaptive from "adaptivecards";
import { TypedCardElementPeer, PropertySheet, PropertySheetCategory, StringPropertyEditor } from "adaptivecards-designer";
import { removeOtherPropertyConfigurations } from "../Utils/CustomElementUtils";
import { ICustomProperty } from "../../../shared/interfaces/customproperties.interface";
import { CustomPropertyBase } from "./CustomPropertyBase";
import { getPropertyEditorInstance, PropertyKeys } from "../Pickers/PickerBase";
export class NumProperty extends CustomPropertyBase {
    static JsonTypeName;
    static ElementId;
    static defaultLabel;
    static customPropertyData: ICustomProperty;

    constructor(paramType, paramCustomPropertyData: ICustomProperty) {
        
        NumProperty.JsonTypeName = paramType ?? NumProperty.JsonTypeName;
        NumProperty.ElementId = paramCustomPropertyData?.PropertyId ?? NumProperty.ElementId;
        NumProperty.defaultLabel = paramCustomPropertyData?.Name ?? NumProperty.defaultLabel;
        NumProperty.customPropertyData = paramCustomPropertyData ?? NumProperty.customPropertyData;
        
        super();
    }

    internalRender(): HTMLElement | undefined {
        if((this?.id ?? "").length == 0)
            this.id = NumProperty.ElementId;

        if((this?.displayLabel ?? "").length == 0)
            this.displayLabel = NumProperty.defaultLabel;

        if((this?.dataType ?? "").length == 0)
            this.dataType = NumProperty.customPropertyData?.DataType ?? "";

        this.requireField ??= NumProperty.customPropertyData?.IsRequired ?? false;

        this.errorMessage ??= NumProperty.customPropertyData?.ErrorMessage ?? "";

        return super.internalRender();
    }


    getJsonTypeName(): string {
        return NumProperty.JsonTypeName;
    }
}

export class NumPropertyPeer extends TypedCardElementPeer<NumProperty> {
    static readonly displayLabelProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "displayLabel", "Label", false);
    static requireFieldProperty = getPropertyEditorInstance(NumProperty.ElementId, PropertyKeys.requireField);
    static readonly requiredMessageProperty = new StringPropertyEditor(Adaptive.Versions.v1_0, "errorMessage", "Error Message", false);

    populatePropertySheet(propertySheet: PropertySheet, defaultCategory: string = PropertySheetCategory.DefaultCategory) {
        super.populatePropertySheet(propertySheet, defaultCategory);
        removeOtherPropertyConfigurations(propertySheet);

        propertySheet.add(
            defaultCategory,
            NumPropertyPeer.idProperty,
            NumPropertyPeer.displayLabelProperty
        );

        propertySheet.add(
            "Validation",            
            NumPropertyPeer.requireFieldProperty,
            NumPropertyPeer.requiredMessageProperty
        );
    }
}